export default __webpack_public_path__ + "static/media/onboarding-graphics-freelancer-agency.c4e01765.png";